<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="spots"
      :single-select="false"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-select
      fixed-header
      height="40vh"
      item-key="id"
      hide-default-footer
      mobile-breakpoint="0"
      :items-per-page="spots.length"
    >
      <template v-slot:[`item.name`]="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.name || "n/c" }}
        </p>
      </template>
      <template v-slot:[`item.mandatoryAttributes`]="{ item }">
        <p class="text-sm text-secondary font-weight-bold mt-4 mb-0">
          {{ getItemsAsStringList(item.mandatoryAttributes) }}
        </p>
      </template>
      <template v-slot:[`item.forbiddenAttributes`]="{ item }">
        <p class="text-sm text-secondary font-weight-bold mt-4 mb-0">
          {{ getItemsAsStringList(item.forbiddenAttributes) }}
        </p>
      </template>
      <template v-slot:[`item.attributes`]="{ item }">
        <p class="text-sm text-secondary font-weight-bold mt-4 mb-0">
          {{ getItemsAsStringList(item.attributes) }}
        </p>
      </template>
      <template v-slot:[`item.isreservable`]="{ item }">
        <p class="text-sm text-secondary font-weight-bold mt-4 mb-0">
          {{ item.isReservable ? "oui" : "non" }}
        </p>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div>
          <v-icon size="18" class="text-typo mr-4" @click="updateItem(item)"
            >mdi mdi-pen</v-icon
          >
          <v-icon size="18" class="text-typo" @click="preventDelete(item)"
            >mdi mdi-delete</v-icon
          >
        </div>
      </template>
    </v-data-table>
    <PreventDelete
      :dialogDelete="dialogDelete"
      :itemToDelete="itemToDelete"
      :loading="loading"
      @abort="abortDelete"
      @confirm="deleteItem"
    ></PreventDelete>
  </div>
</template>

<script>
import PreventDelete from "../common/PreventDelete.vue";

export default {
  name: "SpotListTable",

  components: {
    PreventDelete,
  },

  props: {
    spots: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      selected: [],
      sortBy: "name",
      sortDesc: false,
      headers: [
        {
          text: "PLACE",
          value: "name",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ATTRIBUTS OBLIGATOIRES",
          value: "mandatoryAttributes",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ATTRIBUTS REJETÉS",
          value: "forbiddenAttributes",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ATTRIBUTS",
          value: "attributes",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "RÉSERVABLES",
          value: "isreservable",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
      itemToDelete: null,
      loading: false,
      dialogDelete: false,
    };
  },

  watch: {
    selected(nVal) {
      this.$emit("selectedSpots", nVal);
    },
  },

  methods: {
    updateItem(item) {
      this.$emit("spotToUpdate", item);
    },

    preventDelete(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },

    abortDelete() {
      this.itemToDelete = null;
      this.dialogDelete = false;
    },

    deleteItem(item) {
      this.loading = true;
      this.$store.dispatch("delete_spot", item);
      this.dialogDelete = false;
      this.loading = false;
    },

    /**
     * Take an Array of object like
     * [{name: 'toto', id: 1}, {name: 'tata', id: 2}]
     * and return 'toto, tata'
     *
     * @param {*} items - An array of Object
     * @param {String} k - Is the the key to match, default value is 'name'
     * @returns {String}
     */
    getItemsAsStringList(items, k = "name") {
      const itemsK = items.map((elm) => elm[k]).filter(Boolean);
      return itemsK.join(", ");
    },
  },
};
</script>

<style scoped>
/* OVERWRITE default margin in data table to center text in row*/
.v-application .mt-4 {
  margin-top: 0 !important;
}
</style>
